// import service from '../service'
import service from '../contactsService'
import contactsConfig from '@/utils/contacts/config'
import { configer } from '@/config'

const baseUrl = configer.baseURL
console.log('NODE_ENV：' + process.env.NODE_ENV)
console.log('VUE_APP_CURRENTMODE：' + process.env.VUE_APP_CURRENTMODE)
console.log('baseUrl：' + baseUrl);

// 分页请求
export function pageRequest(pageNum, pageSize, pageCount, api, params) {
    const allApi = []
    for (let i = 0; i < pageCount; i++) {
        pageNum++
        const oneApi = api({
            spaceId: params.spaceId,
            pageNum: pageNum,
            pageSize: pageSize
        })
        allApi.push(oneApi)
    }
    return Promise.all(allApi)
}

// 通过用户uid获取用户详细信息，可批量，ids：['uid1'，'uid2'，'uid3']
export function batchUsers(ids, callback) {
    if (!Array.isArray(ids)) {
        return callback('传入数据格式有误', {
            data: []
        })
    }
    const userList = []
    if (ids.length === 0) {
        callback(null, {
            data: []
        })
        return
    }
    const backUpIds = ids.concat() // 拷贝ids
    let pageNum = 0
    const pageSize = 1000
    const pageCount = Math.ceil(backUpIds.length / pageSize)
    const apis = []
    for (let i = 0; i < pageCount; i++) {
        pageNum++
        const userIds = backUpIds.splice(0, pageSize)
        const api = getUsersFromRemote(userIds, pageNum)
        apis.push(api)
    }
    Promise.all(apis).then(res => {
        let members = []
        for (let i = 0; i < res.length; i++) {
            if (
                res[i].code === '0' &&
                res[i].data &&
                res[i].data.staffList &&
                res[i].data.staffList.length > 0
            ) {
                members = members.concat(res[i].data.staffList)
            }
        }
        if (members.length > 0) {
            // 服务器可能返回 [null]，兼容一下
            const users = members.filter(item => item)
            callback(null, {
                data: formatUserList(userList.concat(users), ids)
            })
        } else {
            callback(null, {
                data: []
            })
        }
    }).catch(err => {
        callback(err, {
            data: []
        })
    })
}

// 根据uid集合查询用户信息
function getUsersFromRemote(uids, pageNum) {
    return service({
        // url: baseUrl + '/contacts/open/lstaff/batchStaff', // 稳定，人数1500上限接口
        url: baseUrl + '/contacts/open/lstaff/v1/batchStaff', // 新接口，支持最多上限2000多人
        method: 'post',
        data: {
            uids,
            pageNum
        }
    })
}
function formatUserList(userList, ids) {
    const arr = []
    for (let i = 0; i < ids.length; i++) {
        for (let j = 0; j < userList.length; j++) {
            if (ids[i] === userList[j]['uId']) {
                userList[j]['id'] = userList[j]['uId'] // 拿到的数据没有id，但是id和uid一样，所以用uid当id加上id属性
                arr.push(userList[j])
            }
        }
    }
    return arr
}

// 通过用户account获取用户详细信息，可批量，accounts：['account1'，'account2'，'account3']
export function batchUsersByAccounts(accounts, callback) {
    if (!Array.isArray(accounts)) {
        return callback('传入数据格式有误', {
            data: []
        })
    }
    const userList = []
    if (accounts.length === 0) {
        callback(null, {
            data: []
        })
        return
    }
    const backUpAccounts = accounts.concat() // 拷贝accounts
    let pageNum = 0
    const pageSize = 1000
    const pageCount = Math.ceil(backUpAccounts.length / pageSize)
    const apis = []
    for (let i = 0; i < pageCount; i++) {
        pageNum++
        const userAccounts = backUpAccounts.splice(0, pageSize)
        const api = getUsersInfoByAccounts(userAccounts, pageNum)
        apis.push(api)
    }
    Promise.all(apis)
        .then(res => {
            let members = []
            for (let i = 0; i < res.length; i++) {
                if (
                    res[i].code === '0' &&
                    res[i].data &&
                    res[i].data.staffList &&
                    res[i].data.staffList.length > 0
                ) {
                    members = members.concat(res[i].data.staffList)
                }
            }
            if (members.length > 0) {
                // 服务器可能返回 [null]，兼容一下
                const users = members.filter(item => item)
                callback(null, {
                    data: formatUserListByAccount(
                        userList.concat(users),
                        accounts
                    )
                })
            } else {
                callback(null, {
                    data: []
                })
            }
        })
        .catch(err => {
            callback(err, {
                data: []
            })
        })
}

// 根据account集合查询用户信息
function getUsersInfoByAccounts(accounts, pageNum) {
    return service({
        // url: baseUrl + '/contacts/open/lstaff/batchByAccounts', // 稳定，人数1500上限接口
        url: baseUrl + '/contacts/open/lstaff/v1/batchByAccounts', // 新接口，支持最多上限2000多人
        method: 'post',
        data: {
            accounts,
            pageNum
        }
    })
}
function formatUserListByAccount(userList, accounts) {
    const arr = []
    for (let i = 0; i < accounts.length; i++) {
        for (let j = 0; j < userList.length; j++) {
            if (accounts[i] === userList[j]['lxAccount']) {
                userList[j]['id'] = userList[j]['uId'] // 拿到的数据没有id，但是id和uid一样，所以用uid当id加上id属性
                arr.push(userList[j])
            }
        }
    }
    return arr
}

// 获取最近聊天
export function getRecentList(data) {
    return service({
        url: baseUrl + '/contacts/open/im/chat/recent',
        method: 'post',
        data: data
    })
}
// 获取常用联系人
export function getContactList(data) {
    return service({
        url: baseUrl + '/contacts/open/favorContact/list',
        method: 'post',
        data: data
    })
}
// 添加常用联系人
export function setFavorContact(userId) {
    return service({
        url: baseUrl + `/contacts/open/favorContact/${userId}`,
        method: 'post'
    })
}
// 删除常用联系人
export function deleteFavorContact(userId) {
    return service({
        url: baseUrl + `/contacts/open/favorContact/${userId}`,
        method: 'delete'
    })
}

// 获取常用群组
export function getFavorGroups(params) {
    return service({
        url: baseUrl + '/contacts/open/favorGroups',
        method: 'get',
        params: params
    })
}

// 获取当前登陆人的我的项目信息
export function getUserProjectInfo() {
    return service({
        url: baseUrl + `/contacts/open/tws/space/myTeams`,
        method: 'get'
    })
}
// 获取当前登陆人的我的项目信息 -> 选人组件(分页)
export function getUserProjectInfoPage(params) {
    return service({
        url: baseUrl + `/contacts/open/tws/space/querySpaces`,
        method: 'get',
        params: params
    })
}

// 根据团队空间ID查询空间下成员及角色信息
export function getProjectDetail(params) {
    return service({
        url: baseUrl + `/contacts/open/tws/v1/space/membersAndRoles`,
        method: 'get',
        params: params
    })
}

// 根据群id查询群成员
export function getGroups(groupId) {
    return service({
        url: baseUrl + `/contacts/open/im/group/members/${groupId}`,
        method: 'get'
    })
}

// 获取我的组织
export function getUserOrgInfo(params) {
    return service({
        url: baseUrl + `/contacts/open/lstaff/organizationInfo`,
        method: 'get',
        params: params
    })
}

// 根据pid查询节点及所有的父节点信息名称
export function getPathListByBizId(pid) {
    return service({
        url: baseUrl + `/contacts/open/parent-nodes-dept/${pid}`,
        method: 'get'
    })
}

// 查询部门下用户数量
export function getOrgMembersCount(data) {
    return service({
        url: baseUrl + '/contacts/open/contact-staff-total-count',
        method: 'post',
        data: data
    })
}
// id集合去重
function unique(array) {
    const map = {}
    return array.filter(item => {
        if (map[item]) {
            return false
        }
        map[item] = item
        return true
    })
}
// 获取该部门下所有的部门和人员id
export function getAllMembers(bizId, callback) {
    getAllMembersNodes(bizId, (error, list) => {
        const depts = []
        const members = []
        let membersId = []
        list.forEach(item => {
            if (item.type === contactsConfig.DEPT) {
                depts.push(item)
            } else if (item.type === contactsConfig.STAFF) {
                membersId.push(item.bizId)
            }
        })
        membersId = unique(membersId)
        if (membersId.length) {
            const backUpIds = membersId.concat() // 拷贝ids
            let pageNum = 0
            const pageSize = 1000
            const pageCount = Math.ceil(backUpIds.length / pageSize)
            const apis = []
            for (let i = 0; i < pageCount; i++) {
                pageNum++
                const userIds = backUpIds.splice(0, pageSize)
                const api = getUsersFromRemote(userIds, pageNum)
                apis.push(api)
            }
            Promise.all(apis)
                .then(res => {
                    let membersData = []
                    for (let i = 0; i < res.length; i++) {
                        if (
                            res[i].code === '0' &&
                            res[i].data &&
                            res[i].data.staffList &&
                            res[i].data.staffList.length > 0
                        ) {
                            membersData = membersData.concat(
                                res[i].data.staffList
                            )
                        }
                    }
                    if (membersData.length > 0) {
                        // 服务器可能返回 [null]，兼容一下
                        const resultList = membersData.filter(item => item)
                        resultList.forEach(item => {
                            item.uId = item.uId || item.bizId
                            item.id = item.uId || item.bizId
                            members.push(item)
                        })
                        callback(error, {
                            depts,
                            members
                        })
                    } else {
                        callback(null, {
                            data: []
                        })
                    }
                })
                .catch(err => {
                    callback(err, {
                        data: []
                    })
                })
        }
    })
}
// 查询部门及子部门下所有人员uId和子部门id
function getAllMembersNodes(bizId, callback) {
    return service({
        url: baseUrl + `/contacts/open/dept-staff-nodes/${bizId}`,
        method: 'get'
    })
        .then(res => {
            callback(null, res.data)
        })
        .catch(e => {
            callback(e)
        })
}

// 向上查找idpath
export function contactsBatch(bizIds) {
    return service({
        url: baseUrl + `/contacts/open/staff-post-nodes/${bizIds}`,
        method: 'get'
    })
}

// 根据组织id获取组织下的详细人员&组织信息
export function getNextOrganization(bizId, callback) {
    getNextOrganizationNodes(bizId, (error, list) => {
        if (error) {
            callback(error, list)
            return
        }
        list.forEach(item => {
            if (item.type === contactsConfig.STAFF) {
                item.uId = item.uId || item.bizId
                item.id = item.uId || item.bizId
                item.portraitUrl = item.portraitUrl || ''
                item.userType = +item.userType || ''
                item.isExec = +item.isExec || 0
                item.nickName = item.ex3 || ''
                item.job = item.tag1 || ''
                item.status = 1 // 后端已过滤，默认给1，在职
            }
        })
        callback(error, list)
    })
}
// 根据pid查询子节点
function getNextOrganizationNodes(pid, callback) {
    return service({
        url: baseUrl + `/contacts/open/child-nodes/${pid}/tree`,
        method: 'get'
    })
        .then(res => {
            if (res.code === '0') {
                callback(null, res.data)
            } else {
                callback('dataLoadingFailed')
            }
        })
        .catch(err => {
            callback(err)
        })
}
// 根据userid获取个人详细信息（个人信息页）
export function getStaffInfo(params) {
    return service({
        url: baseUrl + '/contacts/open/lstaff/v1/staffInfo',
        method: 'get',
        params: params
    })
}
// 根据token获取个人信息
export function getStaffInfoByToken(params) {
    return service({
        url: baseUrl + '/contacts/open/lstaff/staffByToken',
        method: 'get',
        params: params
    })
}
// 根据account获取个人权限
export function getRightsByToken() {
    return service({
        // url: baseUrl + `/contacts/open/authority/query?lxAccount=${lxAccount}`,
		url: baseUrl + `/contacts/open/authority/myContact`,
        method: 'get'
    })
}
// 根据account列表获取userId列表
export function getStaffUIdsByAccount(accounts) {
    return service({
        url: baseUrl + '/contacts/open/lstaff/staff-uid',
        method: 'post',
        data: {
            accounts
        }
    })
}
// 上传头像
export function savePersonalPicture(data) {
    return service({
        url: baseUrl + `/contacts/open/staff-portrait`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    })
}
// 保存个性签名
export function savePersonalSignature(data) {
    return service({
        url: baseUrl + `/contacts/open/savePersonalSignature`,
        method: 'post',
        data
    })
}

// 查询我的部门的第一个和我的项目第一个，通讯录页面展示用
export function getMyDeptAndTwsSpace() {
    return service({
        url: baseUrl + `/contacts/open/config/myDeptAndTwsSpace`,
        method: 'get'
    })
}

// 我的末级部门下的供方人员信息
export function getUserMyPartner() {
    return service({
        url: baseUrl + `/contacts/open/lstaff/lastDept/myPartner`,
        method: 'get'
    })
}

// 获取跳转链接
export function getJumpUrl(params) {
    return service({
        url: baseUrl + `/contacts/open/config/jumpUrls`,
        method: 'get',
        params: params
    })
}

// 搜索联系人
export function contactsSearch(data) {
    return service({
        url: baseUrl + `/contacts/open/search/contactInfo`,
        method: 'post',
        data
    })
}
